import React from 'react';
import { useParams } from 'react-router-dom';
import Blog1 from './blog1';
import Blog2 from './blog2';
import Blog3 from './blog3';
import Blog4 from './blog4';
import Blog5 from './blog5';
import Blog6 from './blog6';
import Blog7 from './blog7';
import Blog8 from './blog8';
import Blog9 from './blog9';
import { blogs } from '../../../utils/constant';
import Seo from '../../../components/Seo';
import { SITE_URL, articleJsonLd, breadcrumbJsonLd } from '../../../utils/seo';

export const BlogDetail = () => {
  const { title } = useParams();
  const titleStringArr = title ? title?.split('-'):[];
  const id = titleStringArr[titleStringArr.length - 1]
  const numericId = Number(id);
  const blog = blogs.find((item) => item.id === numericId);

  return (
    <div className="main">
      {blog && (
        <Seo
          title={`${blog.title} | Koostream`}
          description={blog.description}
          canonical={`${SITE_URL}/blogs/${blog.url}-${blog.id}`}
          image={blog.image}
          type="article"
          publishedTime={blog.date}
          jsonLd={[
            articleJsonLd({
              title: blog.title,
              description: blog.description,
              url: `${SITE_URL}/blogs/${blog.url}-${blog.id}`,
              image: blog.image,
              date: blog.date,
            }),
            breadcrumbJsonLd([
              { name: 'Home', path: '/' },
              { name: 'Blog', path: '/blogs' },
              { name: blog.title, path: `/blogs/${blog.url}-${blog.id}` },
            ]),
          ]}
        />
      )}
      {id === '9' && <Blog9></Blog9>}
      {id === '8' && <Blog8></Blog8>}
      {id === '7' && <Blog7></Blog7>}
      {id === '6' && <Blog6></Blog6>}
      {id === '5' && <Blog5></Blog5>}
      {id === '1' && <Blog1></Blog1>}
      {id === '2' && <Blog2></Blog2>}
      {id === '3' && <Blog3></Blog3>}
      {id === '4' && <Blog4></Blog4>}
    </div>
  );
};
